import * as React from 'react';
import { Palette } from 'styled-components';
import { Circle, CircleProps } from '@tink/core/src/components/atoms/Circle/Circle';
import { IconBaseProps } from '@tink/core/src/components/atoms/Icons/IconBase';

type CircledIconProps = CircleProps & {
  Icon: React.FC<IconBaseProps>;
  iconColor?: Palette;
};

export const CircledIcon: React.FC<CircledIconProps> = ({
  Icon: CoreIcon,
  iconColor,
  ...circleProps
}) => {
  return (
    <Circle size="xlarge" color="primary" {...circleProps}>
      <CoreIcon fontSize="normedium" color={iconColor ?? 'white'} />
    </Circle>
  );
};
